/**
 * Feature Comparison component.
 *
 * @package Schema_AI
 */

import { __ } from '@wordpress/i18n';

const features = [
	{ category: __( 'AI Generation', 'schema-ai' ), items: [
		{ name: __( 'Monthly AI Generations', 'schema-ai' ), free: '30', pro: '300', premium: '1,000' },
		{ name: __( 'Auto-Generate on Publish', 'schema-ai' ), free: false, pro: true, premium: true },
		{ name: __( 'Bulk Generation', 'schema-ai' ), free: false, pro: true, premium: true },
	] },
	{ category: __( 'Schema', 'schema-ai' ), items: [
		{ name: __( 'All Schema Types', 'schema-ai' ), free: true, pro: true, premium: true },
		{ name: __( 'Visual Schema Editor', 'schema-ai' ), free: true, pro: true, premium: true },
		{ name: __( 'Google Rich Results Test', 'schema-ai' ), free: true, pro: true, premium: true },
	] },
	{ category: __( 'Competitor & SEO Tools', 'schema-ai' ), items: [
		{ name: __( 'Analytics Dashboard', 'schema-ai' ), free: true, pro: true, premium: true },
		{ name: __( 'Competitor URL Analyses', 'schema-ai' ), free: '10 / mo', pro: '100 / mo', premium: __( 'Unlimited', 'schema-ai' ) },
		{ name: __( 'Content Gap Analysis', 'schema-ai' ), free: false, pro: true, premium: true },
		{ name: __( 'Optimisation Suggestions', 'schema-ai' ), free: false, pro: true, premium: true },
		{ name: __( 'Google Search Console', 'schema-ai' ), free: false, pro: true, premium: true },
	] },
	{ category: __( 'Agency & Team', 'schema-ai' ), items: [
		{ name: __( 'Multi-Site', 'schema-ai' ), free: false, pro: false, premium: '5 sites (+$5/site)' },
		{ name: __( 'Team Seats', 'schema-ai' ), free: false, pro: false, premium: '3 seats (+$5/seat)' },
	] },
	{ category: __( 'Support', 'schema-ai' ), items: [
		{ name: __( 'Community Support', 'schema-ai' ), free: true, pro: true, premium: true },
		{ name: __( 'Priority Email Support', 'schema-ai' ), free: false, pro: true, premium: true },
		{ name: __( 'Dedicated Support', 'schema-ai' ), free: false, pro: false, premium: true },
	] },
];

function FeatureComparison() {
	const renderValue = ( val ) => {
		if ( val === true ) return <span className="dashicons dashicons-yes-alt schema-ai-fc-yes"></span>;
		if ( val === false ) return <span className="dashicons dashicons-minus schema-ai-fc-no"></span>;
		return <span className="schema-ai-fc-text">{ val }</span>;
	};

	return (
		<div className="schema-ai-feature-comparison">
			<table className="widefat striped">
				<thead>
					<tr>
						<th>{ __( 'Feature', 'schema-ai' ) }</th>
						<th className="schema-ai-fc-plan-col">{ __( 'Free', 'schema-ai' ) }</th>
						<th className="schema-ai-fc-plan-col">{ __( 'Pro', 'schema-ai' ) }</th>
						<th className="schema-ai-fc-plan-col">{ __( 'Premium', 'schema-ai' ) }</th>
					</tr>
				</thead>
				<tbody>
					{ features.map( ( group ) => (
						<>
							<tr key={ group.category } className="schema-ai-feature-group">
								<td colSpan="4"><strong>{ group.category }</strong></td>
							</tr>
							{ group.items.map( ( item ) => (
								<tr key={ item.name }>
									<td>{ item.name }</td>
									<td className="schema-ai-fc-plan-col">{ renderValue( item.free ) }</td>
									<td className="schema-ai-fc-plan-col">{ renderValue( item.pro ) }</td>
									<td className="schema-ai-fc-plan-col">{ renderValue( item.premium ) }</td>
								</tr>
							) ) }
						</>
					) ) }
				</tbody>
			</table>
		</div>
	);
}

export default FeatureComparison;
